import React from 'react';

export const AppContext = React.createContext({
    languageId: 'en',
    authenticatedUser: null,
    selectedAccount: null,
    onLanguageChange: () => {},
    onProfileChange: () => {}
});

AppContext.displayName = 'AppContext';